<template>
  <div class="applications">
    <h1 class="applications__title page-title">
      Applications
    </h1>

    <div class="applications__list card">
      <div
        class="applications__empty-text"
        v-if="applicationArray.length === 0"
      >
        No applications
      </div>
      <div
        v-for="(application, index) in applicationArray"
        :key="application.applicationId"
      >
        <application-preview
          :application-data="application"
          @update-data="fetchApplications"
        />
        <el-divider v-if="index < applicationArray.length - 1" />
      </div>
    </div>
  </div>
</template>

<script>
import { getOutgoingUserApplications } from '@/api/application.js';
import ApplicationPreview from '@/components/applications/ApplicationPreview.vue';

export default {
  name: 'Applications',
  components: {
    ApplicationPreview,
  },
  data() {
    return {
      applicationArray: [],
    };
  },
  methods: {
    async fetchApplications() {
      const { data, success } = await getOutgoingUserApplications();

      if (success) {
        this.applicationArray = data.items;
      }
    },
  },
  created() {
    this.fetchApplications();
  },
};
</script>

<style lang="scss">
.applications {
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);
    font-weight: 500;
    font-size: var(--font-size-800);
  }
  &__list {
  }
  &__empty-text {
  }
}
</style>
